const ROLE_LABELS = {
  owner: 'Proprietário',
  admin: 'Administrador',
  editor: 'Pode editar',
  viewer: 'Somente leitura',
};

const TYPE_LABELS = {
  personal: 'Conta pessoal',
  family: 'Conta familiar',
  shared: 'Compartilhada',
};

const RELATION_LABELS = {
  spouse: 'Cônjuge',
  child: 'Filho/Filha',
  parent: 'Pai/Mãe ou responsável',
  other: 'Outro',
};

const MEMBERSHIP_TYPE_LABELS = {
  permanent: 'Permanente',
  invited: 'Por convite',
};

export const getAccountRoleLabel = (role) => ROLE_LABELS[role] || role || 'Membro';
export const getRelationLabel = (relation) => RELATION_LABELS[relation] || RELATION_LABELS.other;
export const getMembershipTypeLabel = (membershipType) => MEMBERSHIP_TYPE_LABELS[membershipType] || '';

export const getAccountDisplayName = (account) => {
  const name = String(account?.name || '').trim();
  if (!name) return 'Minha conta Nara';
  const normalized = name.toLocaleLowerCase('pt-BR');
  if (['minha conta narafin', 'minha conta anrafin', 'minha conta financefy', 'minha conta financify'].includes(normalized)) return 'Minha conta Nara';
  return name;
};

export const getAccountTypeKey = (account, uid) => {
  if (account?.type) return account.type;
  if (!account || account.ownerUid === uid) return 'personal';
  return account.membership?.membershipType === 'permanent' ? 'family' : 'shared';
};

export const getAccountTypeLabel = (account, uid) => {
  const type = getAccountTypeKey(account, uid);
  return TYPE_LABELS[type] || type;
};
